module.exports = __webpack_public_path__ + "static/media/svg-6.1dbb6f10.svg";